import React, { useState, useEffect } from 'react';
import './EditApplicationModal.css';

const EditApplicationModal = ({ isOpen, onClose, application, onSave }) => {
  const [formData, setFormData] = useState({
    status: '',
    notes: '',
    date_applied: ''
  });
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (application) {
      setFormData({
        status: application.status || '',
        notes: application.notes || '',
        date_applied: application.date_applied || ''
      });
    }
  }, [application]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    
    try {
      await onSave(application.id, formData);
      onClose();
    } catch (error) {
      console.error('Error saving application:', error);
      alert('Failed to save changes. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  if (!isOpen || !application) return null;

  return (
    <div className="edit-modal-overlay" onClick={onClose}>
      <div className="edit-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="edit-modal-header">
          <h2>Edit Application</h2>
          <button className="close-btn" onClick={onClose}>×</button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="form-section">
            <h3>Position Details</h3>
            <div className="readonly-info">
              <div className="info-item">
                <span className="info-label">Job Title:</span>
                <span className="info-value">{application.job?.title}</span>
              </div>
              <div className="info-item">
                <span className="info-label">Company:</span>
                <span className="info-value">{application.job?.company?.name}</span>
              </div>
            </div>
          </div>

          <div className="form-section">
            <h3>Application Status</h3>
            <div className="form-group">
              <label htmlFor="status">Status</label>
              <select
                id="status"
                name="status"
                value={formData.status}
                onChange={handleChange}
                className="form-control"
                required
              >
                <option value="submitted">📝 Submitted</option>
                <option value="interview">🎯 Interview</option>
                <option value="assessment">📊 Assessment</option>
                <option value="offer">🎉 Offer</option>
                <option value="rejected">❌ Rejected</option>
                <option value="withdrawn">↩️ Withdrawn</option>
              </select>
            </div>

            <div className="form-group">
              <label htmlFor="date_applied">Date Applied</label>
              <input
                type="date"
                id="date_applied"
                name="date_applied"
                value={formData.date_applied}
                onChange={handleChange}
                className="form-control"
                required
              />
            </div>
          </div>

          <div className="form-section">
            <h3>Notes</h3>
            <div className="form-group">
              <label htmlFor="notes">Application Notes</label>
              <textarea
                id="notes"
                name="notes"
                value={formData.notes}
                onChange={handleChange}
                className="form-control"
                rows="5"
                placeholder="Add notes about this application..."
              />
            </div>
          </div>

          <div className="modal-actions">
            <button 
              type="button"
              onClick={onClose}
              className="btn-cancel"
              disabled={isLoading}
            >
              Cancel
            </button>
            <button 
              type="submit"
              className="btn-save"
              disabled={isLoading}
            >
              {isLoading ? 'Saving...' : 'Save Changes'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditApplicationModal;

